import { IConComponents } from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/iconComponents.type';
import React from 'react';

const SubstitutionParts: React.FC<IConComponents> = ({
  fill,
  stroke,
  height = '42',
  width = '42',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="21" cy="21" r="21" fill={fill} />
      <g clipPath="url(#clip0_16087_130738)">
        <path
          d="M32.0227 15.1545C31.9896 14.9748 31.919 14.8042 31.8157 14.6536C31.7123 14.5029 31.5784 14.3757 31.4227 14.2802L27.9941 17.7088C27.8342 17.8747 27.6425 18.0067 27.4304 18.0968C27.2183 18.1869 26.9903 18.2334 26.7598 18.2334C26.5294 18.2334 26.3013 18.1869 26.0893 18.0968C25.8772 18.0067 25.6855 17.8747 25.5255 17.7088L24.2227 16.5431C23.9086 16.2226 23.7326 15.7918 23.7326 15.3431C23.7326 14.8944 23.9086 14.4635 24.2227 14.1431L27.6513 10.7145C27.5765 10.5388 27.464 10.3818 27.3218 10.2544C27.1796 10.127 27.0112 10.0324 26.8284 9.97736C25.6321 9.7388 24.3929 9.84091 23.2518 10.2721C22.1107 10.7032 21.1136 11.4461 20.374 12.4162C19.6345 13.3862 19.1821 14.5444 19.0684 15.759C18.9548 16.9735 19.1845 18.1955 19.7313 19.2859L10.3713 28.5602C10.208 28.7199 10.0782 28.9105 9.98967 29.121C9.90109 29.3315 9.85547 29.5576 9.85547 29.7859C9.85547 30.0143 9.90109 30.2404 9.98967 30.4508C10.0782 30.6613 10.208 30.852 10.3713 31.0116L10.9884 31.6288C11.1481 31.7921 11.3387 31.9218 11.5492 32.0104C11.7597 32.0989 11.9858 32.1446 12.2141 32.1446C12.4425 32.1446 12.6685 32.0989 12.879 32.0104C13.0895 31.9218 13.2802 31.7921 13.4398 31.6288L22.7998 22.2859C23.8905 22.8056 25.104 23.0125 26.3053 22.8837C27.5066 22.755 28.6486 22.2955 29.6043 21.5565C30.5601 20.8174 31.2922 19.8278 31.7191 18.6976C32.146 17.5674 32.2511 16.3409 32.0227 15.1545Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16087_130738">
          <rect width="24" height="24" fill={fill} transform="translate(9 9)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SubstitutionParts;
